import { restClient } from '@/Core'
import { AppConfig } from '@/Ship/Configs/AppConfig'

interface ResetPasswordPayload {
    /** Токен із кроку 1. */
    token: string
    /** Код із листа, як його ввела людина. */
    code: string
    plainPassword: string
}

/**
 * Крок 2 відновлення: код із листа і новий пароль.
 *
 * Бек приймає `code` числом (`UserPasswordResetController`, `intval`), а код
 * завжди шестизначний без провідного нуля (100000–999999), тож перетворення
 * нічого не губить. Пробіли, якими людина могла розбити код, прибираємо.
 */
export const ResetPasswordTask = async ({ token, code, plainPassword }: ResetPasswordPayload): Promise<void> => {
    const url = (AppConfig.restResetPasswordUrl ?? '/services/users/{token}/password_reset').replace(
        '{token}',
        encodeURIComponent(token)
    )

    await restClient.patch(
        url,
        {
            json: { code: Number(code.replace(/\s/g, '')), plainPassword },
            headers: { 'Content-Type': 'application/json' },
        },
        { isPublic: true }
    )
}
